import "./styles.scss";
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Link, useNavigate } from "react-router-dom";
import useForm from "../../../hooks/useForm";
import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { SideMenu } from "../../../components/SideMenu";
import { CAMPAINS_GET } from "../../../API/campainApi";
import { APP_POST } from "../../../API/appApi";

export function NewApplication() {
  const [loading, setLoading] = useState(false);
  const [campains, setCampains] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const name = useForm();
  const fk_id_campain = useForm();
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    async function getCampains() {
      setLoading(true);

      const { url, options } = CAMPAINS_GET(token);

      const campainResponse = await fetch(url, options);
      const campainJson = await campainResponse.json();

      setCampains(campainJson.data.data);

      setLoading(false);
    }

    getCampains();
  }, [token]);

  async function handleSubmit(event) {
    event.preventDefault();

    const { url, options } = APP_POST(
      {
        name: name.value,
        fk_id_campain: Number(fk_id_campain.value),
      },
      token
    );

    try {
      setLoading(true);
      const appResponse = await fetch(url, options);
      if (!appResponse.ok) {
        setError(
          "Houve um erro ao enviar os dados, contate o suporte ou tente novamente mais tarde"
        );
      }
      navigate("/app");
    } catch (err) {
      setError(
        "Houve um erro ao enviar os dados, contate o suporte ou tente novamente mais tarde"
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div>
        <SideMenu />
      </div>

      <div className=" fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="header">
              <div>
                <i className="fas fa-ghost"></i>
                <h2>Aplicações</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="formContainer">
          <h2>Cadastro de Nova Aplicação</h2>
          <form className="row" onSubmit={handleSubmit}>
            {error ? <p className="text-danger">{error}</p> : ""}
            <div className="col-md-6 form-group">
              <label htmlFor="name">Nome</label>
              <InputText
                id="name"
                name="name"
                {...name}
                className="form-control"
                required
              />
            </div>

            <div className="col-md-6 form-group">
              <label htmlFor="profile">Campanha</label>
              <br />
              <select
                name="campain"
                id="camapin"
                {...fk_id_campain}
                className="form-control"
                required
              >
                <option value="#">Selecione</option>
                {campains.map((campain) => {
                  return (
                    <option value={campain.id} key={campain.id}>
                      {campain.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="col-md-12 buttonBox">
              <Link to="/app">
                <button className="cancel">Cancelar</button>
              </Link>
              {loading ? (
                <button type="submit" disabled className="register">
                  Cadastrado...
                </button>
              ) : (
                <button type="submit" className="register">
                  Cadastrar
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
